var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100vh" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { staticClass: "mts mr", attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.contact
        ? _c("app-contact-info", {
            attrs: { contact: _vm.contact },
            on: {
              close: function ($event) {
                return _vm.close()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }